/* eslint no-alert: warn */
import type { CollectionError } from '../../error/CollectionError.js';
// import { marketplaceBalanceMw } from '../../middleware/marketplace-balance/marketplaceBalanceMw.js';
// import { marketplaceSharesMw } from '../../middleware/marketplace-shares/marketplaceSharesMw.js';
import { paymentConfirmMw } from '../../middleware/payment-confirm/paymentConfirmMw.js';
import { paymentDone } from '../../middleware/payment-done/paymentDoneMw.js';
import type { PaymentResponseApi } from '../../payment/context/createPaymentResponseApi.js';
import { createPayment, type PostMiddlewareFn, type PreMiddlewareFn } from '../../payment/createPayment.js';
import { type PaymentConfig } from '../../service/PaymentService.js';
import { WagerService } from '../../service/service-wager/WagerService.js';
import { logger } from '../../utils/index.js';
import type { Wager } from '../../wager/Wager.js';

const paymentConfirm = paymentConfirmMw(
  (paymentContext) =>
    new Promise((resolve, reject) => {
      const { title } = paymentContext ?? {};
      // const dialogConfig = {
      //   branding: branding.SPORT,
      //   type: type.DEFAULT,
      //   icon: 'nav-games',
      //   title,
      //   actions: [
      //     {
      //       title: 'Avbryt',
      //       showLoader: true,
      //       callback() {
      //         dialog.api.close();
      //         reject();
      //       }
      //     },
      //     {
      //       title: 'Betala',
      //       showLoader: true,
      //       callback() {
      //         dialog.api.close();
      //         resolve();
      //       }
      //     }

      //   ]
      // };
      // if (customMessage) {
      //   dialogConfig.message = [
      //     {
      //       type: message.TEXT,
      //       text: customMessage
      //     }
      //   ];
      // }
      // dialog.api.add(new Confirm(dialogConfig));

      const isPaymentStillViable = window.confirm(title);
      if (isPaymentStillViable) {
        resolve();
      } else {
        reject(new Error('Payment cancelled by customer'));
      }
    })
);

const paymentDoneMW = paymentDone(
  (paymentSuccessContext, paymentErrorContext) =>
    new Promise((resolve) => {
      if (paymentSuccessContext) {
        const { title /* , message: dialogMessage, mybetsUrl */ } = paymentSuccessContext;
        // dialog.api.add(new Confirm({
        //   branding: branding.SPORT,
        //   type: type.DEFAULT,
        //   icon: 'nav-games',
        //   title,
        //   message: [
        //     {
        //       type: message.TEXT,
        //       text: dialogMessage
        //     }
        //   ],
        //   actions: [
        //     {
        //       title: 'Mina spel',
        //       callback: () => {
        //         onCallback(paymentDoneUtils.TRACKING_ACTIONS.MY_GAMES);
        //         dialog.api.close();
        //         location.href = mybetsUrl;
        //       },
        //       showLoader: true
        //     },
        //     {
        //       title: 'Okej',
        //       callback: () => {
        //         onCallback(paymentDoneUtils.TRACKING_ACTIONS.OK);
        //         dialog.api.close();
        //         resolve();
        //       },
        //       showLoader: true
        //     }
        //   ]
        // }));
        window.alert(title);
        resolve();
      } else if (paymentErrorContext) {
        // const { clientErrors } = paymentErrorContext;
        window.alert('Error');
        resolve();
      }
    })
);

// const marketplaceBalance = marketplaceBalanceMw(
//   (balanceSuccessContext) =>
//     new Promise((resolve) => {
//       if (balanceSuccessContext) {
//         const { title, message, balance, price, wagerCount } = balanceSuccessContext;
//         // eslint-disable-next-line no-alert
//         window.alert(
//           `Title: ${title}, Message: ${message}, Balance: ${balance}, Price: ${price}, Wager Count: ${wagerCount}`
//         );
//         resolve();
//       }
//     })
// );

// const marketplaceShares = marketplaceSharesMw(
//   (marketplaceSharesSuccessContext) =>
//     new Promise((resolve) => {
//       if (marketplaceSharesSuccessContext) {
//         const { title, message, balance, numberOfNewShares } = marketplaceSharesSuccessContext;
//         // eslint-disable-next-line no-alert
//         window.alert(
//           `Title: ${title}, Message: ${message}, Balance: ${balance}, Number of New Shares: ${numberOfNewShares}`
//         );
//         resolve();
//       }
//     })
// );

/*
  const createWagerAsync: IWagerService['createWagerAsync'] = async (coupons, { wallet }) => {
    const wagers: Wager[] = [];
    for (const coupon of coupons) {
      wagers.push(createWager(coupon, { wallet }));
    }

    const [response, error] = await payWagers({ wagers });

    const paidItems = response.getPaidPayableItems();
    const unpaidItems = response.getUnpaidPayableItems();

    if (paidItems.length === 0) {
      if (error) {
        throw error;
      }

      throw new InternalError('Failed to place wager');
    }

    const result = {
      transactionIds: response.getPaidPayableItemsDTO().map((d) => d.transactionId),
      paidAmount: response.getPaidAmount(),
      paidItemsCount: paidItems.length,
      unpaidItemsCount: unpaidItems.length,
    } as const;

    return result;
  };
*/

type MarketplaceWagerPaymentFlowParams<TConfig> = {
  wagers: Wager[];
  config?: TConfig;
  isC2C?: boolean;
  extraPreMiddleware?: PreMiddlewareFn[];
  extraPostMiddleware?: PostMiddlewareFn[];
};

/**
 * Function to pay wagers.
 * Handles middleware setup and flow for paying wagers.
 *
 * @param props parameters
 * @param props.wagers wagers to pay
 * @param props.config payment config
 * @param props.extraPreMiddleware extra pre middleware to add to flow
 * @param props.extraPostMiddleware extra post middleware to add to flow
 * @returns result and error
 */
export async function payMarketplaceWagers<TPaymentConfig extends PaymentConfig>({
  wagers,
  config,
  // isC2C = false,
  extraPreMiddleware,
  extraPostMiddleware,
}: MarketplaceWagerPaymentFlowParams<TPaymentConfig>): Promise<
  readonly [PaymentResponseApi<Wager>, CollectionError | undefined]
> {
  const paymentBuilder = createPayment(new WagerService(config)).addPayable(...wagers);

  if (extraPreMiddleware) {
    for (const middleware of extraPreMiddleware) {
      paymentBuilder.addPreMiddleware(middleware);
    }
  }

  // paymentBuilder.addPreMiddleware(marketplaceBalance);
  // if (isC2C) {
  //   paymentBuilder.addPreMiddleware(marketplaceShares);
  // }
  paymentBuilder.addPreMiddleware(paymentConfirm);
  paymentBuilder.addPostMiddleware(paymentDoneMW);

  if (extraPostMiddleware) {
    for (const middleware of extraPostMiddleware) {
      paymentBuilder.addPostMiddleware(middleware);
    }
  }

  const [result, error] = await paymentBuilder.execute();
  const paidWagers = result.getPaidPayableItems();

  for (const wager of paidWagers) {
    if (wager.activatedDrawId) {
      // getAccountBalance.deleteBalance(wager.activatedDrawId);
      logger.debug('Paid marketplace wager with activated draw', {
        activatedDrawId: wager.activatedDrawId,
        wagerId: wager.localId,
      });
    }
  }

  return [result, error] as const;
}
